import CSCProductCard from "components/CSCProductCard";
import Divider from "components/Divider";
import SellSheetPagination from "containers/SellSheet/SellSheetPagination";
import { BaseProp } from "entities/BaseProp";
import { ProductDataList } from "entities/ClearanceDTO";
import usePagination from "hooks/usePagination";
import React, { useMemo } from "react";
import { stringToSlug } from "utils/stringToSlug";
import useDarkSky from "../hooks/useDarkSky";
import { DarkSkyFilterParameter } from "../types";

type DarkSkyAccessories = BaseProp & {
  accessoriesList: ProductDataList[];
  filters:DarkSkyFilterParameter;
};

const DarkSkyAccessories = (props: DarkSkyAccessories) => {
  const { accessoriesList,filters } = props;
  const { applyFilters } = useDarkSky();

  // const filteredItems = useMemo(() => {
  //     const dataSet = accessoriesList;
  //     if (!dataSet) return [];
  
  //     return applyFilters(accessoriesList, filters);
  //   }, [accessoriesList, filters]);


  const {
    currentItems,
    currentPage,
    itemsPerPage,
    onPageChange,
    setCurrentPage,
  } = usePagination(accessoriesList, 24, "scrollPaginationTab");

  return (
    <>
      <Divider />
      <div className="max-w-screen-sm scroll-mt-32" id="scrolloptionalacc">
        <h1 className="block text-2xl sm:text-3xl font-semibold text-custom-grey dark:text-slate-300">
          DarkSky Supported Accessories
        </h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-10 mt-8 lg:mt-10">
        {currentItems.map((item, index) => (
          <CSCProductCard
            name={item.productName}
            category={item.productNumber}
            description={item.prodDescription}
            image={item.lowResImages || undefined}
            link={`/product-details/${stringToSlug(
              item.productNumber
            ).toUpperCase()}`}
            key={index}
            linkTarget="_self"
            secondaryLink={"/banners-detail"}
          />
        ))}
      </div>
      {/* PAGINATION */}
      <SellSheetPagination
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        totalItems={accessoriesList?.length as number}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default DarkSkyAccessories;
